import React, { useEffect, useState } from 'react';
import {
  DataTableColumn,
  DataTableRow,
} from '@common/components/datatable/types';
import { useTranslation } from 'react-i18next';
import { DotLabel, Tag, GridDataItem } from './components';
import moment from 'moment';
import Profile from '@common/components/profile';
import { RatingType } from '../../types';

export default (gridData: GridDataItem[] = []) => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<DataTableColumn[]>([]);

  useEffect(() => {
    const getGridLabel = (potential: number, performance: number): GridDataItem | undefined => {
      const matchedGrid = gridData.find(
        (grid) => grid.potential === potential && grid.performance === performance
      );

      return matchedGrid;
    };

    const baseColumns: DataTableColumn[] = [
      {
        key: 'employee',
        label: t('common:employees'),
        options: {
          sortable: true,
          render: (row: DataTableRow) => {
            return (
              <div className="tw-flex tw-items-center tw-gap-3">
                <a
                  href={`/admin/users/${row.reviewee.id}/about`}
                  target="_blank" rel="noreferrer"
                >
                  <Profile user={row.reviewee} size={24} />
                </a>
              </div>
            );
          },
        },
      },
      {
        key: 'potential',
        label: t('performance:potential'),
        options: {
          sortable: true,
          align: 'left',
          render: (row: DataTableRow) => (
            <Tag level={row.talent_review?.potential} type={RatingType.PERFORMANCE} />
          ),
        },
      },
      {
        key: 'performance',
        label: t('performance:performance'),
        options: {
          sortable: true,
          align: 'left',
          render: (row: DataTableRow) => (
            <Tag level={row.talent_review?.performance} type={RatingType.PERFORMANCE} />
          ),
        },
      },
      {
        key: 'nine_box',
        label: t('performance:9_box_grid'),
        options: {
          render: (row: DataTableRow) => {
            const potential = row.talent_review?.potential;
            const performance = row.talent_review?.performance;
              const gridLabel =
              potential && performance
                ? getGridLabel(potential, performance)
                : '-';
            return <DotLabel gridLabel={gridLabel as GridDataItem} />;
          },
        },
      },
      {
        key: 'retention_risk',
        label: t('performance:retention_risk'),
        options: {
          align: 'left',
          sortable: true,
          render: (row: DataTableRow) => (
            <Tag level={row.talent_review?.retention_risk} type={RatingType.RETENTION_RISK} />
          ),
        },
      },
      {
        key: 'impact_of_loss',
        label: t('performance:impact_of_loss'),
        options: {
          render: (row: DataTableRow) => (
            <div className="tw-text-gray-text tw-text-base tw-font-medium">
              {row.talent_review?.impact_of_loss ?? '-'}
            </div>
          ),
        },
      },
      {
        key: 'completed_at',
        label: t('performance:completed_at'),
        options: {
          sortable: true,
          renderLite: (value: string) => (
            <div className="tw-flex tw-justify-center">
              <span className="tw-text-base tw-text-gray-text tw-font-medium tw-font-inter">
                {moment(value).format('MMM D, YYYY')}
              </span>
            </div>
          ),
        },
      }
    ];
    setColumns(baseColumns);
  }, [t, gridData]);

  return columns;
};
